import reducerRegistry from 'reduxUtils/reducerRegistry';
import makeRequest from 'utils/makeRequest';
import { getFeedUrl } from 'helpers/feeds/generalHelpers';
import produce from 'immer';
import _get from 'lodash.get';

const reducerName = 'otherbulisting';
const createActionName = name => `toi/${reducerName}/${name}`;

export const RECEIVE_OTHER_BU_LISTING_DATA = createActionName(
  'RECEIVE_OTHER_BU_LISTING_DATA',
);

export const HANDLE_OTHER_BU_LISTING_DATA_ERROR = createActionName(
  'HANDLE_OTHER_BU_LISTING_DATA_ERROR',
);

export const RECEIVE_LEAD_VIDEO_DATA = createActionName(
  'RECEIVE_LEAD_VIDEO_DATA',
);

export const HANDLE_LEAD_VIDEO_DATA_ERROR = createActionName(
  'HANDLE_LEAD_VIDEO_DATA_ERROR',
);

export const MAGICBRICKS_BU = 'magicbricks';

const VIDEOSECPATH = {
  [MAGICBRICKS_BU]: '/toi/web/list/video?path=/videos/times-property',
};

const OTHER_BU_LISTING_CONTENT_FEED_PATH = {
  [MAGICBRICKS_BU]: 'https://www.magicbricks.com/blog/getTopArticles',
};

function fetchOtherBUListingWidgetData(buUnit) {
  const CONFIG = {
    headers: {
      'Content-Type': 'application/json',
      TOIKey: 'TOIMBArticlesIJQGgOJs8l',
    },
  };
  const feedPath = OTHER_BU_LISTING_CONTENT_FEED_PATH[buUnit];
  return makeRequest.get(feedPath, CONFIG, 'skipfeedengine');
}

function fetchLeadVideoFromVideosSection(buUnit, isWapView) {
  const feedPath = VIDEOSECPATH[buUnit];
  const url = `${getFeedUrl()}${feedPath}`;
  return makeRequest.get(url, { isMobile: isWapView }, 'skipfeedengine');
}

function receiveOtherBUListingWidgetData(data) {
  return {
    type: RECEIVE_OTHER_BU_LISTING_DATA,
    payload: data,
  };
}

function handleOtherBUListingWidgetDataError() {
  return {
    type: HANDLE_OTHER_BU_LISTING_DATA_ERROR,
    payload: {},
  };
}

function receiveLeadVideoFromVideosSection(data) {
  return {
    type: RECEIVE_LEAD_VIDEO_DATA,
    payload: data,
  };
}

function handleLeadVideoFromVideosError() {
  return {
    type: HANDLE_LEAD_VIDEO_DATA_ERROR,
    payload: {},
  };
}

export function loadLeadVideoFromVideosSection(buUnit, isWapView) {
  return dispatch =>
    fetchLeadVideoFromVideosSection(buUnit, isWapView)
      .then(response => {
        if (response.data) {
          const videoItems = _get(response.data, 'data.items');
          if (Array.isArray(videoItems) && videoItems.length > 0) {
            const retData = { section: buUnit, videodata: videoItems[0] };
            dispatch(receiveLeadVideoFromVideosSection(retData));
          }
        }
      })
      .catch(error => {
        dispatch(handleLeadVideoFromVideosError(error));
      });
}

export function loadOtherBUListingWidgetData(buUnit) {
  return dispatch =>
    fetchOtherBUListingWidgetData(buUnit)
      .then(response => {
        const retData = {
          [buUnit]: response.data,
        };
        dispatch(receiveOtherBUListingWidgetData(retData));
      })
      .catch(error => {
        dispatch(handleOtherBUListingWidgetDataError(error));
      });
}

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_OTHER_BU_LISTING_DATA: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case HANDLE_OTHER_BU_LISTING_DATA_ERROR: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case RECEIVE_LEAD_VIDEO_DATA: {
      const { section = '' } = action.payload;
      const { videodata = {} } = action.payload;
      const nextState = produce(state, draftState => {
        const buListData = _get(draftState, 'data');
        const sectionData = _get(buListData, section);
        if (
          sectionData &&
          !Array.isArray(sectionData) &&
          typeof sectionData === 'object'
        ) {
          sectionData.videoitem = videodata;
        }
      });
      return nextState;
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
